module.exports = __webpack_public_path__ + "static/media/red.faa1ba3a.png";